import { Helmet } from 'react-helmet-async';

import { AccountDocuments } from './_authenticated._main.company/AccountDocuments';
import { Label } from '../components/atomic/Label';
import { Spinner } from '../components/Spinner';
import { useFetchAccount } from '../hooks/useFetchAccount';
import { t } from '../services/translation/translation';

export const CompanyRoute = () => {
  const { data: account, isLoading } = useFetchAccount();

  return (
    <div className="max-w-screen-md m-auto">
      <Helmet>
        <title>{t('common.company')} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white mb-6">{t('common.company')}</h3>
      <div className="flex items-start gap-4 flex-wrap">
        <div className="block md:max-w-3xl p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 min-w-full sm:min-w-0">
          <h6 className="text-lg font-bold dark:text-white mb-2">{t('common.info')}</h6>

          {isLoading ? <Spinner /> : null}
          {account ? (
            <div className="grid gap-4 sm:grid-cols-2 auto-rows-auto whitespace-">
              <div>
                <Label>{t('company-route.company-name')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.legalName ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('common.status')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.legalStatus ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('company-route.owner-name')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-ellipsis">
                  {account.owner ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('common.address')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {[account.addressStreet, account.addressZipCode, account.addressCity, account.addressCountry]
                    .filter(v => !!v)
                    .join(',') || '--'}
                </p>
              </div>
              <div>
                <Label>{t('common.email')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.email ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('common.phone')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.phoneNumber ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('company-route.use-tva')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.tva ? t('common.yes') : t('common.no')}
                </p>
              </div>
              <div>
                <Label>{t('common.vat-number')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.tvaNumber ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('common.invoicing-id')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.invoiceId ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('common.siren')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.siren ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('company-route.rcs-city')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.sirenCity ?? '--'}
                </p>
              </div>
              <div>
                <Label>{t('company-route.ape-naf')}</Label>
                <p className="font-normal text-gray-500 dark:text-gray-400 overflow-hidden text-">
                  {account.apeNaf ?? '--'}
                </p>
              </div>
            </div>
          ) : null}
        </div>
        <AccountDocuments />
      </div>
    </div>
  );
};
